import request from '@/utils/request'

export function getAllShops(data) {
  return request({
    url: 'get/all/shops',
    method: 'post',
    params: data
  })
}

